import {
  ORBIT_ONE_TYPES_SOURCE,
  WidgetConfigSiteTabbedShell,
} from '@/components/widgetConfigSiteTabbedShell/index.ts';
import { WidgetConfigModalProps } from '@/types.ts';

import { BiomassDistributionForm } from './biomassDistributionModalContent/BiomassDistributionForm.tsx';

interface BiomassDistributionModalContentProps extends WidgetConfigModalProps {
  rootId?: string;
}

export const BiomassDistributionModalContent = ({
  rootId,
  widgetId,
  ...rest
}: BiomassDistributionModalContentProps) => (
  <WidgetConfigSiteTabbedShell
    source={ORBIT_ONE_TYPES_SOURCE}
    widgetId={widgetId}
    {...rest}
    showSave
    renderSitePanel={() => <BiomassDistributionForm rootId={rootId} />}
  />
);
